import Vue from 'vue'
import { MemoryStorage, WebStorage } from 'vue-ls/src/storage/index.js'
// 直接一点，少出bug
Vue.use({
  /**
   * Install plugin
   * @param {Object} Vue
   * @param {Object} options
   * @returns {WebStorage}
   */
  install(Vue) {
    // eslint-disable-next-line
    const _global = (typeof window !== 'undefined' ? window : global || {});
    if (Vue.ls || Vue.prototype.$ls) {
      throw new Error('Vue.ls或Vue.prototype.$ls 已经存在')
    }
    if (Vue.ss || Vue.prototype.$ss) {
      throw new Error('Vue.ss 或Vue.prototype.$ss 已经存在')
    }
    const lsWebStorage = new WebStorage('localStorage' in _global ? _global.localStorage : MemoryStorage)
    lsWebStorage.setOptions({
      name: 'ls',
      storage: 'local'
    })
    Vue.ls = lsWebStorage
    Vue.prototype.$ls = lsWebStorage
    const ssWebStorage = new WebStorage('sessionStorage' in _global ? _global.sessionStorage : MemoryStorage)
    ssWebStorage.setOptions({
      name: 'ss',
      storage: 'session'
    })
    Vue.ss = ssWebStorage
    Vue.prototype.$ss = ssWebStorage
  }
})
